import http from '../utils/http-common';

export interface AiqPaymentRecord {
  _id: string;
  user?: { _id: string; email: string; name?: string };
  tier: 'learner' | 'certified';
  amount: number;
  currency: string;
  paymentStatus: 'pending' | 'paid' | 'consumed' | 'failed' | 'refunded';
  stripeSessionId?: string;
  paidAt?: string;
  consumedAt?: string;
  createdAt?: string;
}

const getAiqPayments = (offset: number = 0, limit: number = 20) =>
  http.get<{ data: { payments: AiqPaymentRecord[]; total: number } }>(
    `/admin/stripe/aiq-payments?offset=${offset}&limit=${limit}`
  );

const AiqPaymentsService = { getAiqPayments };

export default AiqPaymentsService;
